import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddForm(props) {
  return(
    <PostAdd 
      targetVid={"webform_categories"}
      addPostEndpoint={apiEndpoints.forms}
      editRoute={"/forms/edit"}
      entityType={"webform"}
      pageTitle={"Create a form post"}
      returnRoute={"/forms-creator"}
      categoryName={"forms"}
    />
  )
}
